<h2>
  <mat-icon>warning</mat-icon> WARNING
</h2>
<ul>
  @for (warning of warningList; track warning) {
    <li>
      {{ warning }}
    </li>
  }
</ul>
